<div class="parallax-mirror" style="
    visibility: visible;
    z-index: -100;
    position: fixed;
    top: 58.1676px;
    left: 0px;
    overflow: hidden;
    transform: translate3d(0px, 0px, 0px);
    height: 609px;
    width: 100%;
  ">
  <img class="parallax-slider" src="../../../assets/images/parallax-07.jpg" style="
      transform: translate3d(0px, 0px, 0px);
      position: absolute;
      height: 535px;
      width: 100%;
      max-width: none;
    " />
</div>

<!-- HEADER -->
<main role="main">
  <!-- Section 1 -->
  <article>


    <header class="section background-green background-transparent text-center" data-parallax="scroll"
      data-image-src="images providental/parallax-07.jpg">
      <div class="line">
        <div class="margin-top-bottom-20">
          <!-- Title Strings -->

          <h1 class="text-white text-size-40 text-thin text-line-height-1">Providental gaat met pensioen !</h1>
        </div>
      </div>
    </header>


  </article>
  <!-- Section 2 -->

  <section class="section background-white">
    <div class="full-width text-center"> <img src="../../../assets/images/Covers/Cover pensioen.png" class="center"
        style="margin-top: -210px;">
      <div class="line">
        <h2 class="headline text-thin text-s-size-16">Na 42 jaar gaat de deur in het slot !&nbsp; &nbsp;(*)&nbsp;&nbsp;
        </h2>
        <p class="text-size-20 text-s-size-16 text-thin">Met veel plezier en passie hebben wij de afgelopen jaren voor u
          klaargestaan.</p>
        <p class="text-size-20 text-s-size-16 text-thin">Nu is het tijd om de agenda leeg te maken en te gaan genieten
          van een nieuwe fase.<br>
          Wij willen u hartelijk danken voor het jarenlange vertrouwen en de fijne contacten.<br>
          <br>
          Derhalve zullen deze <strong>website</strong>, de <strong>e-shop</strong> en het online
          <strong>groothandels</strong>&nbsp; bestel<strong>prog</strong>ramma <br>
          binnenkort niet meer bereikbaar zijn.
        </p>
        <p class="text-size-20 text-s-size-16 text-thin">&nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin">Aspecten van Providental leven verder in een andere gedaante in
          een Internationale context, <br>
          maar in Antwerpen eindigt het verhaal.</p>
        <p class="text-size-20 text-s-size-16 text-thin"><br>
          Voor vragen over lopende zaken of dossiers kunt u nog tijdens een uitloopperiode, beperkt in tijd,<br>
          terecht bij info@providental.be /&nbsp; 03 226 00 81/&nbsp; order@providental.com</p>
        <p class="text-size-20 text-s-size-16 text-thin">&nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin"><br>
          <br>
          Met oprechte dank voor een mooi verhaal en <br>
          met&nbsp; vriendelijke groet,
        </p>
        <p class="text-size-20 text-s-size-16 text-thin">Team Providental</p>
        <p class="text-size-20 text-s-size-16 text-thin">&nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin">&nbsp;</p>
        <p class="text-size-20 text-s-size-16 text-thin">(* <em>Providental is opgericht in</em> <strong>1984</strong>
          <em>met een aandeelhouderswissel in</em> <strong>1993</strong>.)</p>
      </div>
    </div>
  </section>
  <section class="section background-white padding">
    <div class="line">
      <div class="margin"> </div>
    </div>
  </section>
  </main>